/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Social_ActionInputs */

const en_lg_social_action = /** @type {(inputs: Lg_Social_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how to interact`)
};

const id_lg_social_action = /** @type {(inputs: Lg_Social_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat cara berinteraksi`)
};

/**
* | output |
* | --- |
* | "See how to interact" |
*
* @param {Lg_Social_ActionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_social_action = /** @type {((inputs?: Lg_Social_ActionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Social_ActionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_social_action(inputs)
	return en_lg_social_action(inputs)
});